/**
 * Default group names that get auto-created when an admin adds a new account
 * to the create-account form. These remain client-side because they're a UX
 * convenience, not a domain catalog.
 */
export const DEFAULT_GROUP_NAMES = ["Ansatte", "Ledere"] as const;
